import Api from './Api';

const END_POINT = 'puestos'

export default {
    async get_all(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request);
    },
    async store(puesto) {
        return await Api.post(`${END_POINT}`, puesto);
    },
    async update(puesto) {
        return await Api.patch(`${END_POINT}/${puesto.id}`, puesto);
    },
    async change_status(puesto) {
        return await Api.patch(`${END_POINT}/${puesto.id}/change-status`, puesto);
    },
    async delete(puesto) {
        return await Api.delete(`${END_POINT}/${puesto.id}`, puesto);
    },
    async listarActivos() {
        return await Api.get('listarPuestosActivos');
    }
}